import {Injectable} from '@angular/core';
import {RegisterDataTableService} from '../../../core/services/register-data-table.service';
import {StorageService} from '../../../core/services/storage.service';
import {ITableColumn} from '../../../core/common/interfaces/table-column.interface';


@Injectable({
  providedIn: 'root'
})
export class IndicatorTableService extends RegisterDataTableService {


  constructor(
    storageService: StorageService
  ) {
    super(storageService);
  }


  override getColumns(): ITableColumn[] {
    return [
      {
        name: 'id',
        title: 'Id',
        default: true,
        useCustomTemplate: false,
      },
      {
        name: 'name',
        title: 'Показатель',
        default: true,
        useCustomTemplate: false,
      },
      {
        name: 'shortName',
        title: 'Условное обозначение',
        default: true,
        useCustomTemplate: false,
      },
      {
        name: 'period',
        title: 'Тип оценки',
        useCustomTemplate: true,
        default: true,
      },
      {
        name: 'weight',
        title: 'Вес показателя',
        default: true,
        useCustomTemplate: false,
      },
      {
        name: 'cbTypes',
        title: 'ЦБ',
        default: true,
        useCustomTemplate: false,
      },
      {
        name: 'implementerType',
        title: 'Исполнитель',
        default: true,
        useCustomTemplate: true,
      },
      {
        name: 'indexCount',
        title: 'Количество индексов',
        default: true,
        useCustomTemplate: false,
      },

      {
        name: 'status',
        title: 'Архив',
        useCustomTemplate: true,
        default: false,
      },
    ];
  }


}
